import React from 'react';
import { motion } from 'framer-motion';
const problems = [{
  emoji: '😰',
  title: 'Llegás sin saber qué hacer',
  desc: 'Sin saber qué rutina de compra o qué proveedor vas a trabajar hoy.'
}, {
  emoji: '📦',
  title: 'Stock que no rota',
  desc: 'Sin estructura clara para comprar lo que realmente se vende.'
}, {
  emoji: '💸',
  title: 'No sabés si ganás o perdés',
  desc: 'La plata entra y sale pero no sabés tu ganancia real nunca.'
}, {
  emoji: '📱',
  title: 'Publicás y el silencio es total',
  desc: 'Sin saber qué escribir, cómo fotografiar ni cómo cerrar en el DM.'
}, {
  emoji: '🔄',
  title: 'Clientas que no vuelven',
  desc: 'Sin un sistema claro para que vuelvan y te recomienden solas.'
}, {
  emoji: '👗',
  title: 'Siempre los mismos proveedores',
  desc: 'Sin acceso a mayoristas confiables que te den buen precio y calidad.'
}, {
  emoji: '📉',
  title: 'No sabés cómo fijar el precio',
  desc: 'Te da miedo cobrar de más y terminás trabajando casi gratis.'
}, {
  emoji: '⏳',
  title: 'Fin de mes sin progreso visible',
  desc: 'Sin sobrecarga progresiva en tu negocio, no avanzás nunca.'
}];
export function ProblemSection() {
  return <section className="w-full py-10 sm:py-20" data-id="element-222">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-224">
          <p className="text-gold text-xs sm:text-sm tracking-widest mb-3 sm:mb-4 text-center" data-id="element-225">
            ¿TE PASA ESTO?
          </p>
          <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-white text-center mb-4" data-id="element-226">
            Si emprendés en moda en Argentina, esto te suena familiar:
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 mt-8 sm:mt-12" data-id="element-227">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} whileHover={{
          x: 4,
          backgroundColor: 'rgba(46, 16, 101, 0.4)'
        }} whileTap={{
          scale: 0.98
        }} className="flex gap-3 sm:gap-4 items-start p-3 sm:p-4 rounded-lg transition-colors cursor-default" data-id="element-228">
              <span className="text-2xl sm:text-3xl flex-shrink-0" data-id="element-229">
                {problem.emoji}
              </span>
              <div data-id="element-230">
                <h3 className="font-semibold text-white text-sm sm:text-base mb-1" data-id="element-231">
                  {problem.title}
                </h3>
                <p className="text-xs sm:text-sm text-violet-100/70" data-id="element-232">
                  {problem.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center text-lg sm:text-2xl font-display font-semibold text-gold mt-8 sm:mt-12" data-id="element-233">
          ¿Cuántos meses más vas a emprender improvisando?
        </motion.p>
      </div>
    </section>;
}